// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__35BDR","label":"Section_label__2D02R","contentWrap":"Section_contentWrap__2HRvJ","footer":"Section_footer__3Q3mL","footerInner":"Section_footerInner__1f0R0"};